import type { FusionDefinition } from './types';

export const FUSIONS: readonly FusionDefinition[] = [
  { weaponId: 'diabolo', upgradeId: 'double-faisceau', resultId: 'pluie-de-diabolos' },
  { weaponId: 'cerceaux', upgradeId: 'nova-xxl', resultId: 'anneaux-solaires' },
  { weaponId: 'totem', upgradeId: 'sub-renforce', resultId: 'totem-sono' },
  { weaponId: 'baton-de-feu', upgradeId: 'jambes-de-danseur', resultId: 'double-baton' },
  { weaponId: 'frisbee', upgradeId: 'bonnes-ondes', resultId: 'frisbees-en-passes' },
  { weaponId: 'ruban-arc-en-ciel', upgradeId: 'double-tempo', resultId: 'arc-en-ciel-du-drop' },
  { weaponId: 'monocycle', upgradeId: 'deuxieme-souffle', resultId: 'monocycle-reparateur' },
  { weaponId: 'monocycle', upgradeId: 'pas-chasse', resultId: 'monocycle-filant' },
];
